'use strict';
import get from 'lodash/get';
import isString from 'lodash/isString';
import noop from 'lodash/noop';
import {isCordovaBuild} from '../../config/constants';
import {getCollection, getId} from '../../core-utilities/domain/ReduxUtils';
import {FILE_COLLECTION} from '../../files/domain/config';
import {fileIsImage} from '../../files/domain/FileDomain';
import template from './photo-zoom-modal.html';


FilePreviewService.$inject = [
  '$window',
  '$modal',
  'FileDomain',
  '$download',
];

export function FilePreviewService(
  $window,
  $modal,
  FileDomain,
  $download,
) {
  const ERRORS = this.ERRORS = {
    IN_PROGRESS: 'IN_PROGRESS',
    CANCELLED: 'CANCELLED',
    ERROR: 'ERROR'
  };

  this.openPreviewer = openPreviewer;
  this.cancel = noop;

  function openPreviewer(file, {files, name} = {}) {
    // TODO: set up ability to request the next/previous image while in the previewer
    if (fileIsImage(file)) {
      const urls = _retrieveUrls(file, files);
      return __openImage(urls);

    } else {
      return __openNonImage(file, name);
    }
  }

  function _retrieveUrls(file, files) {
    const retrievedUrlsSorted = [];
    const fileId = get(file, 'key', getId(file));
    const retrievedUrls = [];
    let fileIsFound = false;
    let currentIndex;
    let i, length;

    if (files) {
      for (i = 0, length = files.length; i < length; i++) {
        if (get(files[i], 'key', getId(files[i])) === fileId) {
          fileIsFound = true;
          currentIndex = i;
        }

        retrievedUrls[i] = __getImageUrl(files[i]);
      }

      if (!fileIsFound) {
        currentIndex = 0;
        files.unshift(file);
        retrievedUrls[currentIndex] = __getImageUrl(file);
      } else if (currentIndex !== 0) {
        for (i = 0, length = files.length; i < length; i++) {
          let cycledIndex = (i - currentIndex) % length;
          cycledIndex = cycledIndex < 0 ? length + cycledIndex : cycledIndex;
          retrievedUrlsSorted[cycledIndex] = retrievedUrls[i]
        }

        return retrievedUrlsSorted;
      }

      return retrievedUrls;
    } else {
      retrievedUrls[0] = __getImageUrl(file);
      return retrievedUrls;
    }
  }

  function __openImage(retrievedUrls) {
    return $modal.show({
      template: template,
      controller: 'ImageZoomDialogController',
      locals: {imageUrls: retrievedUrls, currentIndex: 0}
    });
  }

  function __getImageUrl(file) {
    if (file && file.url) {
      return file.url;
    } else if (file && file.fileUri) {
      return file.fileUri;
    } else {
      return null;
    }
  }

  function __openNonImage(file, name) {
    if (getCollection(file) === FILE_COLLECTION) {
      return FileDomain.getUrl(getId(file)).then(url => {
        if (isString(url)) {
          if (isCordovaBuild()) {
            return $download.promptDownload(url, name, {autoOpen: true});
          } else {
            $window.open(url, '_blank');
          }
        } else {
          return Promise.resolve(ERRORS.ERROR);
        }
      }).catch(e => {
        console.warn('open failed');
        console.error(e);
        return Promise.resolve(ERRORS.ERROR);
      });
    } else {
      return Promise.reject(ERRORS.ERROR);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/file-viewer/FilePreviewService.js